import React from 'react';
import './Network.css';
import networkData from '../data/network.json';
import {
  buildContactPrefillHash,
  getCryptoSpacesPartnershipUrl,
  navigateToContactPrefill
} from '../constants';
import { getNetworkSectionContent } from '../utils/contentLoader';
import { useCanvasAnimation } from '../hooks/useCanvasAnimation';

function Network() {
  const { canvasRef, containerRef } = useCanvasAnimation();
  const header = getNetworkSectionContent();
  const cards = networkData.cards || [];
  const handlePrimaryCtaClick = (e, primaryCta) => {
    e.preventDefault();
    navigateToContactPrefill({
      service: primaryCta?.service,
      message: primaryCta?.message
    });
  };

  return (
    <section id="network" className="network" ref={containerRef}>
      <canvas ref={canvasRef} className="network-canvas" aria-hidden="true" />
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">{header.title || 'My Network'}</h2>
          <div className="section-divider" />
          <p className="section-subtitle">
            {header.subtitle ||
              'Connections that turn goals into the right introductions—online, IRL, and across Web3.'}
          </p>
        </div>

        <div className="network-grid">
          {cards.map((card) => {
            const primaryHref = buildContactPrefillHash({
              service: card.primaryCta?.service,
              message: card.primaryCta?.message
            });
            const secondary = card.secondaryCta;
            const secondaryHref =
              secondary?.useCryptoSpacesReferralForm
                ? getCryptoSpacesPartnershipUrl('Home')
                : secondary?.externalUrl || null;

            return (
              <article key={card.id} className="network-card">
                <div className="network-card-icon" aria-hidden="true">
                  <i className={card.icon} />
                </div>
                <h3 className="network-card-title">{card.title}</h3>
                <div className="network-partners" role="list">
                  {card.partners?.map((p) => (
                    <span key={p.name} className="network-partner-badge" role="listitem">
                      {p.url ? (
                        <a href={p.url} target="_blank" rel="noopener noreferrer">
                          {p.name}
                        </a>
                      ) : (
                        <span>{p.name}</span>
                      )}
                    </span>
                  ))}
                </div>
                <ul className="network-bullets">
                  {card.bullets?.map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
                </ul>
                <div className="network-card-actions">
                  {card.primaryCta && (
                    <a
                      href={primaryHref}
                      className="network-cta network-cta-primary"
                      onClick={(e) => handlePrimaryCtaClick(e, card.primaryCta)}
                    >
                      {card.primaryCta.label}{' '}
                      <span className="network-cta-arrow" aria-hidden="true">
                        →
                      </span>
                    </a>
                  )}
                  {secondaryHref && secondary && (
                    <a
                      href={secondaryHref}
                      className="network-cta network-cta-secondary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {secondary.label}{' '}
                      <span className="network-cta-arrow" aria-hidden="true">
                        ↗
                      </span>
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Network;
